<template>
	<div class="loader">
		<i class="fal fa-spinner-third fa-spin fa-4x"></i>
	</div>
</template>
